import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

const AcquisitionModeList = Loadable(
  lazy(() => import("features/acquisitionMode/components/List"))
);
const AcquisitionModePage = Loadable(
  lazy(() => import("features/acquisitionMode/components/Page"))
);

const routes = {
  path: "acquisitionMode",
  children: [
    { path: "", element: <AcquisitionModeList /> },
    { path: "add", element: <AcquisitionModePage /> },
    { path: "edit/:acquisitionModeID?", element: <AcquisitionModePage /> },
  ],
};

export default routes;
